import { Image } from 'expo-image';
import { View } from 'react-native';
import {
  createStyleSheet,
  UnistylesRuntime,
  useStyles,
} from 'react-native-unistyles';

import { Button, Text } from '@/ui';

type TripsEmptyStateProps = {
  onPress: () => void;
};

export function TripsEmptyState({ onPress }: TripsEmptyStateProps) {
  const { styles, theme } = useStyles(stylesheet);

  const carImage =
    UnistylesRuntime.themeName === 'dark'
      ? require('../../../public/images/cars/fallback-car-dark.png')
      : require('../../../public/images/cars/fallback-car-light.png');

  return (
    <View style={styles.container}>
      <Image
        source={carImage}
        style={styles.illustration}
        contentFit="contain"
      />

      <View style={styles.copy}>
        <Text type="title2" tx="trips.emptyStateTitle" style={styles.center} />

        <Text
          type="bodyRegular"
          tx="trips.emptyStateBody"
          style={[styles.center, { color: theme.colors.text.secondary }]}
        />
      </View>

      <View style={styles.ctaRow}>
        <Button
          tx="trips.emptyStateCta"
          type="primary"
          onPress={onPress}
          style={styles.cta}
        />
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet(() => ({
  container: {
    flexGrow: 1,
    width: '100%',
    gap: 16,
    paddingVertical: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  illustration: {
    width: '100%',
    height: 150,
  },
  copy: {
    width: '100%',
    gap: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  center: {
    width: '100%',
    textAlign: 'center',
  },
  ctaRow: {
    width: '100%',
    alignItems: 'center',
  },
  cta: {
    width: 'auto',
    minWidth: 150,
  },
}));
